export enum CallType {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND',
    INTERNAL = 'INTERNAL',
}
